import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Button } from '@mui/material';
import { Sheet } from '../../components';
import BillForm from './BillForm';
import InvoiceFlow from './InvoiceFlow';
import VendorChecksFlow from './VendorChecksFlow';
import { formatDay } from './dates';

export default function AddMenu({ date, accounts, setAuth, onClose, onSaved }) {
  const { t, i18n } = useTranslation();
  const [choice, setChoice] = useState(null);
  return (
    <Sheet open onClose={onClose} title={`${t('calendar.add')} · ${formatDay(date, i18n.language)}`} size='sm'>
      {!choice && (
        <Stack spacing={2}>
          <Button variant='contained' size='large' onClick={() => setChoice('invoice')}>{t('calendar.addInvoice')}</Button>
          <Button variant='contained' size='large' onClick={() => setChoice('recurring')}>{t('calendar.addBill')}</Button>
          <Button variant='contained' size='large' onClick={() => setChoice('once')}>{t('calendar.addOnce')}</Button>
          <Button variant='contained' size='large' onClick={() => setChoice('vendorChecks')}>{t('calendar.vendorChecks.title')}</Button>
        </Stack>
      )}
      {choice === 'invoice' && <InvoiceFlow date={date} accounts={accounts} setAuth={setAuth} onSaved={onSaved} onCancel={() => setChoice(null)} />}
      {(choice === 'recurring' || choice === 'once') && (
        <BillForm mode={choice} date={date} accounts={accounts} setAuth={setAuth} onSaved={onSaved} onCancel={() => setChoice(null)} />
      )}
      {choice === 'vendorChecks' && <VendorChecksFlow date={date} accounts={accounts} setAuth={setAuth} onSaved={onSaved} onCancel={() => setChoice(null)} />}
    </Sheet>
  );
}
